import { Directive, AfterContentChecked, HostListener, inject } from '@angular/core';
import { HisPlamComponent } from '../../structure/component/plam/his-plam.component';
import { HisFileUploadComponent } from '../../upload/component/his-file-upload.component';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'his-file-upload',
    standalone: false
})
export class HisFileUploadDirective implements AfterContentChecked {
    private fileupload = inject(HisFileUploadComponent, { optional: true });
    private hisPlamRef = inject(HisPlamComponent, { host: true, optional: true, self: true });

	
    private msg: string;

    ngAfterContentChecked(): void {
        if(this.fileupload) {
            if(this.fileupload != undefined && this.fileupload.pFileUpload != undefined){
                this.hisPlamRef = this.fileupload.plamRef;
                if(this.fileupload.pFileUpload.msgs != undefined){
                    this.msg = this.fileupload.pFileUpload.msgs[0]?.text;
                    this.hisPlamRef.setErrorMessageBeforeSave(this.msg);
                }
            }
        }
    }  
}